import { InitialQueryState, SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useClipWorkflows, UseClipWorkflowsArgs } from './useClipWorkflows';
import { useSelectedClip } from './useSelectedClipSelectors';
import { useMemo } from 'react';

export const useSelectedClipWorkflows = (
    initialArgs: InitialQueryState = {},
) => {
    const { selectedClip } = useSelectedClip();
    const queryArgs: SkipOrArgs<UseClipWorkflowsArgs> = useMemo(() => {
        if (!selectedClip || !selectedClip.mediaObjectId) return skipToken;
        return { mediaObjectIds: [selectedClip.mediaObjectId] };
    }, [selectedClip]);
    return useClipWorkflows(initialArgs, queryArgs);
};
